var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"primary"}},[(_vm.userObj.avatar)?_c('img',{attrs:{"src":_vm.apiAttachmentUrl(_vm.userObj.avatar) + (_vm.cache ? '' : '?cache-reset=' + new Date()),"alt":"John"}}):_c('b',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.identificationNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }